'use client';

import { __assign } from '../../../_virtual/_tslib.js';
import React__default, { memo, useContext, useState, useMemo, useEffect } from 'react';
import TreeSelect from '../../../TreeSelect/index.js';
import { EVariant } from '../../../TreeSelect/types.js';
import { SearchBarContext } from '../../context/reducer.js';
import InfoOverview from '../../../icons/InfoOverviewGroupIcons/index.js';
import { ACTIONS } from '../../context/actions.js';
import { EForceControDropdown } from '../../context/types.js';
import { parseJSON } from '../../../Utils/utilities.js';

function Locations() {
    var _a = useContext(SearchBarContext), state = _a.state, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isShow = state.isShow;
    var _b = useState([]), locations = _b[0], setLocations = _b[1];
    var isMobile = props.isMobile, langCode = props.langCode, dataProvider = props.dataProvider, optionList = props.optionList, searchBarOptions = props.searchBarOptions;
    var locationDistricts = dataProvider === null || dataProvider === void 0 ? void 0 : dataProvider.getDistricts();
    var forceLimitDisplay = useMemo(function () {
        if (isShow || ((searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) && !isMobile)) {
            return 3;
        }
        return 1;
    }, [isMobile, isShow, searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage]);
    var memoDelayTimeToShowDroupdown = useMemo(function () {
        if ((searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) || isShow) {
            return 0;
        }
        return 380;
    }, [isShow, searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage]);
    var updateLocations = function (locations) {
        setLocations(locations);
        dispatch({
            type: ACTIONS.SET_LOCATIONS,
            payload: locations
        });
    };
    useEffect(function () {
        var _a;
        // case default update locations
        if (searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate) {
            var localStorageParams = parseJSON(localStorage.getItem('params') || '');
            updateLocations((_a = localStorageParams === null || localStorageParams === void 0 ? void 0 : localStorageParams.locations) !== null && _a !== void 0 ? _a : []);
        }
        var handleOnEventSearch = function (e) {
            var _a;
            var searchEvent = e;
            var locations = ((_a = searchEvent === null || searchEvent === void 0 ? void 0 : searchEvent.detail) === null || _a === void 0 ? void 0 : _a.params).locations;
            if (typeof locations !== 'object')
                return;
            updateLocations(locations !== null && locations !== void 0 ? locations : []);
        };
        window.addEventListener('SEARCH', handleOnEventSearch);
        return function () {
            window.removeEventListener('SEARCH', handleOnEventSearch);
        };
    }, [searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isNeedNavigate]);
    return (React__default.createElement(TreeSelect, { langCode: langCode, textOptions: {
            headerLabel: t('Location'),
            inputPlaceholder: t('All locations'),
            maxLimitText: t('You have selected up to three locations')
        }, options: optionList, childrenList: locationDistricts, value: locations, onValueChange: function (value) {
            updateLocations(value !== null && value !== void 0 ? value : []);
        }, onShowDropdown: function (isShowDropdown) {
            if (isShowDropdown || !isShow) {
                dispatch({
                    type: ACTIONS.FORCE_CONTROL,
                    payload: EForceControDropdown.JUST_SHOW_DROPDOWN_TREE_SELECT
                });
            }
        }, onCloseDropdown: function (_, isShowDropdown) {
            if (!isShow) {
                return;
            }
            if (!isShowDropdown) {
                dispatch({
                    type: ACTIONS.FORCE_CONTROL,
                    payload: EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT
                });
            }
        }, selectOptions: { isFilter: true }, styleOptions: {
            variant: EVariant.SECONDARY,
            leftIcon: function (props) { return React__default.createElement(InfoOverview.LocationIOS16GlyphIcon, __assign({}, props)); },
            forceLimitDisplay: forceLimitDisplay,
            arrowDownSize: {
                width: 20,
                height: 20
            }
        }, dropdownStyleOptions: {
            width: '350px',
            borderRadius: 16,
            marginTop: 12,
            delayTime: memoDelayTimeToShowDroupdown,
            isForceClose: true
        }, floatingConfig: {
            position: 'fixed',
            enablePortal: true,
            useWindowAsFlippingContainer: true,
            isFlip: false,
            placement: 'bottom-end'
        }, isMobile: isMobile, isDisabledClearValue: !(searchBarOptions === null || searchBarOptions === void 0 ? void 0 : searchBarOptions.isHomepage) && !isShow }));
}
var Locations$1 = memo(Locations);

export { Locations$1 as default };
//# sourceMappingURL=index.js.map
